<template>
  <div>
    <table-widget
      :items="awards"
      :perPage="perPage"
      :totalRows="totalRows"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <!-- <template v-slot:buttons>
        <b-button v-if="manageAwards" class="mx-2" variant="primary" v-b-modal.awards-modal @click="selectedAwards = null"><font-awesome-icon icon="plus"/> Manage Awards</b-button>
      </template> -->
      <template v-slot:content>
        <b-table
          striped
          :items="awards"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          small
          show-empty
          empty-filtered-text="There are no awards that match your search criteria."
        >
          <template v-slot:cell(awardNumber)="data">
            <a :href="awardUrl + data.item.id" target="_blank">{{
              data.item.awardNumber
            }}</a>
          </template>
          <template v-slot:cell(awardTitle)="data">
            <a :href="awardUrl + data.item.id" target="_blank">{{
              data.item.awardTitle
            }}</a>
          </template>
          <template v-slot:cell(primaryInvestigator)="data">
            <span v-if="data.item.primaryInvestigator"
              >{{ data.item.primaryInvestigator.firstName }}
              {{ data.item.primaryInvestigator.lastName }}</span
            >
          </template>
          <template v-slot:cell(source)="data">
            <span v-if="data.item.source">{{ data.item.source.name }}</span>
          </template>
          <template v-slot:cell(originatingSponsor)="data">
            <span v-if="data.item.originatingSponsor">{{
              data.item.originatingSponsor.name
            }}</span>
          </template>
          <template v-slot:cell(details)="data">
            <a :href="awardUrl + data.item.id" target="_blank">Details</a>
          </template>
          <template v-slot:cell(startDate)="data">
            {{ data.item.startDate | formatDate }}
          </template>
          <template v-slot:cell(endDate)="data">
            {{ data.item.endDate | formatDate }}
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      items: [],
      fields: [
        { key: "awardTitle", label: "Title" },
        { key: "primaryInvestigator" },
        { key: "source" },
        { key: "status" },
        { key: "startDate", sortable: true },
        { key: "endDate", sortable: true, label: "Last Updated" },
        { key: "originatingSponsor" },
        { key: "details", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedAwards: null,
      showAwardsForm: false,
    };
  },

  props: {
    awards: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    manageAwards: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
  },

  components: {
    "table-widget": TableWidget,
  },

  computed: {
    awardUrl: function () {
      return process.env.NODE_ENV !== "production"
        ? "https://communitypartnerships-dev.chs.asu.edu/awards/"
        : "https://communitypartnerships.chs.asu.edu/awards/";
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    displayAward(award) {
      return (
        award.awardTitle +
        " (" +
        award.awardNumber +
        ")<br/>" +
        "PI: " +
        award.primaryInvestigator.firstName +
        " " +
        award.primaryInvestigator.lastName
      );
    },
  },
  watch: {
    awards: function () {
      if (this.awards) {
        this.items = _.clone(this.awards);
      }
    },
  },
  created() {
    if (this.awards) {
      this.items = _.clone(this.awards);
    }
  },
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}
table {
  font-size: 10pt;
}
</style>
